import moment from 'moment'
import { useMemo } from 'react'
import CalendarPicker from 'app/components/marketing/CalendarPicker'
import { PickerButton } from './PickerButton'

/** The became-a-lead date: today by default, never in the future. */
export function LeadDatePicker({ value, onChange }: { value: Date; onChange: (d: Date) => void }) {
  const label = useMemo(() => {
    const day = moment(value).startOf(`day`)
    const today = moment().startOf(`day`)
    const diff = day.diff(today, `days`)
    if (diff === 0) return `Today`
    if (diff === -1) return `Yesterday`
    return day.year() === today.year() ? day.format(`MMM D`) : day.format(`MMM D, YYYY`)
  }, [value])
  return (
    <PickerButton label={label} contentClassName="w-80 p-2">
      {(close) => (
        <CalendarPicker
          date={moment(value).format()}
          onDateChange={(d) => {
            onChange(d)
            close()
          }}
          limitToMonth={false}
          allowPastDates
          allowFutureDates={false}
        />
      )}
    </PickerButton>
  )
}
